import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { Promise } from "rsvp"

/**
 * A macro that creates a computed property that watches for changes in the relationship
 * property of modelName and returns the specified, related object by extracting the id
 * and type of model in the JSON:API object specified in the modelName field,
 * queries the store, and returns a promise proxy that resolves to the related model.

 * @param  {String} modelName - name of the model whose relationship property being looked at by the CP mentioned above
 * @param  {String} relationship - name of document/model expected in the relationship property of the modelName
 * @return {PromiseProxyObject} - this CP returns a proxy whose value can be accessed via the content property
 */
export default function belongsTo(modelName, relationship) {
  var ObjectPromiseProxy = ObjectProxy.extend(PromiseProxyMixin)
  /**
   * Example

    ``` javascript
      class exampleComponent extends Component {
        planbook = { id: 1, type: "planbook", relationships: { rotationCalendar: { data: { type: "rotation-calendar"; id: 2 } } } }
        @belongsTo("planbook", "rotationCalendar") rotationCalendar
      }

      when promise is fulfilled will return rotationCalendar = {id: 2, type: "rotation-calendar", relationships: {planbook: { id: 1} } }
    ```

   */
  return computed(`${modelName}.relationships.${relationship}.data.id`, function () {
    let model = get(this, "modelName")
    let relation = get(this, `${modelName}.relationships.${relationship}`) || {}
    let type = get(relation, "data.type")
    let id = get(relation, "data.id")
    // let promise = (
    //   isNone(get(this, `${modelName}.relationships.${relationship}.data.id`))
    //     ? null
    //     : get(this, 'store').find(type, id)
    let promise = type === undefined ? new Promise(() => {}) : get(this, "store").find(type, id)
    return ObjectPromiseProxy.create({
      promise: promise,
    })
  })
}

// export default Ember.Helper.helper(belongsTo);
